<!-- Hero-buscador -->
<section class="relative pt-16 pb-14 md:pt-24 md:pb-20 px-margin-mobile overflow-hidden bg-background">
  <!-- Decorative gradient blobs -->
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <div class="absolute -top-24 -left-20 w-72 h-72 md:w-96 md:h-96 bg-primary-fixed/20 rounded-full blur-3xl animate-blob"></div>
    <div class="absolute top-1/3 -right-16 w-64 h-64 md:w-80 md:h-80 bg-whatsapp-green/20 rounded-full blur-3xl animate-blob" style="animation-delay: 3s"></div>
    <div class="absolute bottom-0 left-1/4 w-56 h-56 bg-primary-fixed-dim/20 rounded-full blur-3xl animate-blob" style="animation-delay: 6s"></div>
  </div>

  <div class="container-max flex flex-col items-center text-center gap-5">
    <div class="inline-flex items-center gap-2 px-4 py-2 bg-surface border border-outline-variant/30 shadow-sm text-primary rounded-full">
      <span class="material-symbols-outlined text-sm" style="font-variation-settings: 'FILL' 1;">smart_toy</span>
      <span class="font-sans font-semibold text-[13px] uppercase tracking-wider">IA para tu carrera</span>
    </div>

    <h1 class="font-sans text-display-hero-mobile md:text-display-hero text-on-surface max-w-2xl font-bold tracking-tight">
      Encuentra tu próxima <span class="text-whatsapp-green">chamba</span> hoy
    </h1>

    <p class="font-sans text-body-lg text-on-surface-variant max-w-xl font-light">
      Miles de vacantes en LATAM. Busca gratis, postula por WhatsApp y da seguimiento sin salir del chat.
    </p>

    <!-- Buscador -->
    <div class="w-full max-w-4xl bg-white rounded-3xl shadow-soft border border-outline-variant/30 p-4 md:p-5 mt-4 text-left">
      <div class="relative mb-3">
        <span class="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-on-surface-variant">search</span>
        <input
          type="search"
          class="w-full rounded-full bg-surface-container-low border border-outline-variant/40 pl-12 pr-4 py-3.5 text-sm focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none transition-all"
          placeholder="Puesto, empresa o palabra clave (ej. 'soldador')"
          [(ngModel)]="filtros.q"
          (keyup.enter)="buscarChamba()"
          aria-label="Buscar vacantes"
        />
      </div>

      <!-- 1 col en móvil / 2 en sm / 4 en lg: la opción más larga
           ("Cualquier modalidad") no cabe en una celda de 4 columnas del
           buscador y el select la recorta (QA: "Cualquier modalida"). -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2.5">
        <select
          class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
          [(ngModel)]="filtros.sector"
          aria-label="Sector"
        >
          <option [ngValue]="undefined">Todos los sectores</option>
          @for (cat of categorias; track cat.id) {
            <option [ngValue]="cat.id">{{ cat.nombre }}</option>
          }
        </select>

        <select
          class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
          [ngModel]="filtros.pais"
          (ngModelChange)="onPaisChange($event)"
          aria-label="País"
        >
          <option value="">Todos los países</option>
          @for (pais of paises; track pais.code) {
            <option [value]="pais.code">{{ pais.nombre }}</option>
          }
        </select>

        <div class="relative">
          <input
            type="text"
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            placeholder="Ciudad"
            [ngModel]="filtros.ciudad"
            (ngModelChange)="onCiudadInput($event)"
            (blur)="ocultarSugerenciasConDelay()"
            (focus)="onCiudadFocus()"
            autocomplete="off"
            aria-label="Ciudad"
          />
          @if (sugerenciasUbicacion().length > 0) {
            <ul class="absolute z-10 mt-1 w-full bg-white rounded-xl shadow-soft border border-outline-variant/30 max-h-56 overflow-y-auto text-left">
              @for (s of sugerenciasUbicacion(); track s.etiqueta) {
                <li>
                  <button type="button" class="w-full text-left px-3 py-2 text-sm hover:bg-surface-container-low"
                    (click)="elegirUbicacion(s)">
                    {{ s.etiqueta }}
                  </button>
                </li>
              }
            </ul>
          }
        </div>

        <select
          class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
          [(ngModel)]="filtros.modalidad"
          aria-label="Modalidad"
        >
          <option [ngValue]="undefined">Cualquier modalidad</option>
          <option value="PRESENCIAL">Presencial</option>
          <option value="REMOTO">Remoto</option>
          <option value="HIBRIDO">Híbrido</option>
        </select>
      </div>

      <button type="button" (click)="buscarChamba()" class="btn-primary w-full mt-3.5">
        <span class="material-symbols-outlined">search</span>
        Buscar chamba
      </button>
    </div>

    <div class="flex flex-col sm:flex-row items-center gap-3 mt-2">
      <button type="button" (click)="openLogin()" class="btn-whatsapp shadow-whatsapp-glow">
        <img src="assets/icons/whatsapp-icon.png" alt="" width="22" height="20" class="w-5 h-auto">
        Regístrate gratis y postula
      </button>
      <span class="text-xs text-on-surface-variant">100% gratis para candidatos · Registro en segundos</span>
    </div>

    <div class="flex items-center gap-6 sm:gap-8 pt-4 mt-2 border-t border-outline-variant/30 w-full max-w-md justify-center">
      @for (m of metricas; track m.etiqueta; let last = $last) {
        <div class="text-center">
          <p class="font-sans font-bold text-xl sm:text-2xl text-primary mb-1">{{ m.valor }}</p>
          <p class="text-[12px] text-on-surface-variant font-medium">{{ m.etiqueta }}</p>
        </div>
        @if (!last) {
          <div class="w-px h-8 bg-outline-variant/50"></div>
        }
      }
    </div>
  </div>
</section>

@if (loginModalOpen()) {
  <app-login-modal (closed)="closeLogin()" />
}

<!-- Vacantes destacadas -->
<section class="section !pt-10">
  <div class="container-max">
    <div class="flex items-end justify-between mb-8 gap-4">
      <div>
        <h2 class="font-sans text-headline-lg">Vacantes recién publicadas</h2>
        <p class="text-on-surface-variant mt-1">Postúlate gratis en segundos, directo desde tu cuenta de Chambia.</p>
      </div>
      <a routerLink="/vacantes" class="hidden sm:inline-flex items-center gap-1 text-primary font-bold text-sm shrink-0 hover:underline">
        Ver todas
        <span class="material-symbols-outlined text-lg">chevron_right</span>
      </a>
    </div>

    @if (cargandoVacantes()) {
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3.5">
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
          <div class="rounded-2xl h-44 animate-pulse bg-surface-container-low"></div>
        }
      </div>
    } @else if (vacantesDestacadas().length === 0) {
      <div class="bg-white rounded-3xl shadow-soft border border-outline-variant/30 text-center py-16 px-6">
        <p class="text-on-surface-variant text-sm">Aún no hay vacantes publicadas — vuelve pronto, publicamos todos los días.</p>
      </div>
    } @else {
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3.5">
        @for (v of vacantesDestacadas(); track v.id) {
          <app-job-card [vacante]="v" />
        }
      </div>
    }

    <div class="text-center mt-8 sm:hidden">
      <a routerLink="/vacantes" class="btn-secondary">Ver todas las vacantes</a>
    </div>
  </div>
</section>

<!-- Cómo funciona -->
<section id="como-funciona" class="section bg-stone-bg">
  <div class="container-max text-center">
    <h2 class="font-sans text-headline-lg mb-4">¿Cómo funciona?</h2>
    <p class="text-on-surface-variant max-w-lg mx-auto mb-16">
      Encuentra tu próxima chamba en tres pasos, sin CVs aburridos ni formularios interminables.
    </p>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
      <!-- connective line for desktop -->
      <div class="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-outline-variant/40 -z-0"></div>
      @for (paso of pasos; track paso.titulo) {
        <div class="relative flex flex-col items-center text-center gap-5 bg-white md:bg-transparent rounded-3xl md:rounded-none p-8 md:p-0 shadow-soft md:shadow-none border border-outline-variant/30 md:border-none">
          <div
            class="w-20 h-20 rounded-3xl flex items-center justify-center shadow-sm relative z-10"
            [class.bg-surface-container-highest]="paso.color === 'primary'"
            [class.text-primary]="paso.color === 'primary'"
            [class.text-secondary]="paso.color === 'secondary'"
            [class.bg-whatsapp-green]="paso.color === 'whatsapp'"
            [class.text-white]="paso.color === 'whatsapp'"
            [style.background-color]="paso.color === 'secondary' ? 'rgba(18,140,126,0.12)' : null"
          >
            <span class="material-symbols-outlined text-4xl">{{ paso.icono }}</span>
          </div>
          <div>
            <h3 class="font-sans text-headline-md mb-2">{{ paso.titulo }}</h3>
            <p class="text-on-surface-variant">{{ paso.descripcion }}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- Categorías -->
<section class="section">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Chamba para todos</h2>
      <p class="text-on-surface-variant mt-2">Cientos de empresas en estas industrias te esperan.</p>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
      @for (cat of categorias; track cat.id) {
        <a
          [routerLink]="['/vacantes', 'categoria', cat.slug]"
          class="group bg-surface p-6 md:p-8 rounded-3xl shadow-sm border border-outline-variant/30 flex flex-col items-center gap-4 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-primary/50 hover:shadow-primary-glow"
        >
          <div class="w-16 h-16 rounded-full bg-surface-container-low text-primary flex items-center justify-center transition-colors duration-300 group-hover:bg-primary group-hover:text-white">
            <span class="material-symbols-outlined text-3xl">{{ cat.icono }}</span>
          </div>
          <span class="font-bold text-sm">{{ cat.nombre }}</span>
        </a>
      }
    </div>
  </div>
</section>

<!-- Testimonios -->
<section class="section bg-background">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Historias reales de chamba</h2>
      <p class="text-on-surface-variant mt-2">Miles de personas ya encontraron trabajo con Chambia.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      @for (t of testimonios; track t.nombre) {
        <div class="bg-surface rounded-3xl p-8 shadow-sm flex flex-col gap-5 border border-outline-variant/30 hover:border-primary/40 hover:-translate-y-1 transition-all duration-300">
          <span class="material-symbols-outlined text-4xl text-primary/40" style="font-variation-settings: 'FILL' 1;">format_quote</span>
          <p class="font-sans text-body-md text-on-surface-variant flex-1">&ldquo;{{ t.texto }}&rdquo;</p>
          <div class="flex items-center gap-3 pt-4 border-t border-outline-variant/30">
            <div class="w-11 h-11 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold">
              {{ t.nombre.charAt(0) }}
            </div>
            <div>
              <div class="font-bold text-sm">{{ t.nombre }}</div>
              <div class="text-on-surface-variant text-xs">{{ t.puesto }} en {{ t.ciudad }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- Pricing / Planes para candidatos -->
<section id="planes" class="section bg-background">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Planes para candidatos</h2>
      <p class="text-on-surface-variant mt-2">Acelera tu búsqueda con herramientas de IA.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">
      @for (plan of planes; track plan.nombre) {
        <div
          class="bg-white p-8 md:p-10 rounded-[2rem] relative overflow-hidden flex flex-col transition-transform duration-300"
          [ngClass]="plan.destacado
            ? 'shadow-primary-glow border-2 border-primary md:-translate-y-4'
            : 'shadow-soft border border-outline-variant/40'"
        >
          @if (plan.destacado) {
            <div class="absolute top-0 right-0 bg-secondary text-white px-4 py-1.5 font-mono text-[10px] rounded-bl-2xl uppercase tracking-widest">
              Recomendado
            </div>
          }
          <h3 class="font-sans text-headline-md">{{ plan.nombre }}</h3>
          <p class="text-on-surface-variant mb-6 text-sm">{{ plan.descripcion }}</p>
          <div class="font-mono text-3xl mb-6" [class.text-secondary]="plan.destacado" [class.text-primary]="!plan.destacado">
            ${{ plan.precio }} <span class="text-sm font-medium text-on-surface-variant">{{ plan.moneda }}</span>
          </div>
          <ul class="space-y-3 mb-8 flex-1">
            @for (feature of plan.features; track feature) {
              <li class="flex items-center gap-2 text-sm">
                <span class="material-symbols-outlined text-lg" [class.text-secondary]="plan.destacado" [class.text-primary]="!plan.destacado">
                  {{ plan.destacado ? 'star' : 'check_circle' }}
                </span>
                {{ feature }}
              </li>
            }
          </ul>
          <a
            [href]="whatsappLink"
            target="_blank"
            rel="noopener"
            class="w-full py-3.5 rounded-full text-center font-bold transition-all"
            [ngClass]="plan.destacado
              ? 'bg-secondary text-white shadow-amber-glow hover:scale-[1.03]'
              : 'border-2 border-primary text-primary hover:bg-primary/5'"
          >
            {{ plan.cta }}
          </a>
        </div>
      }
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="section">
  <div class="container-max max-w-3xl">
    <h2 class="font-sans text-headline-lg text-center mb-12">Preguntas frecuentes</h2>
    <div class="flex flex-col gap-4">
      @for (faq of faqs; track faq.pregunta) {
        <div class="bg-white rounded-2xl border border-outline-variant/60 shadow-soft overflow-hidden">
          <button
            type="button"
            class="w-full p-5 flex justify-between items-center gap-4 cursor-pointer text-left hover:bg-surface-container-low/60 transition-colors"
            (click)="toggleFaq(faq)"
            [attr.aria-expanded]="faq.open"
          >
            <span class="font-bold text-sm">{{ faq.pregunta }}</span>
            <span
              class="material-symbols-outlined shrink-0 transition-transform text-primary"
              [class.rotate-180]="faq.open"
            >expand_more</span>
          </button>
          @if (faq.open) {
            <div class="px-5 pb-5 text-on-surface-variant text-sm border-t border-outline-variant/30 pt-4">{{ faq.respuesta }}</div>
          }
        </div>
      }
    </div>
  </div>
</section>

<!-- CTA final -->
<section class="section pb-32 md:pb-section-gap">
  <div class="container-max bg-primary rounded-[3rem] p-10 md:p-20 text-center text-white relative overflow-hidden">
    <div class="absolute inset-0 opacity-10 pointer-events-none bg-grid-white"></div>
    <div class="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
    <div class="relative z-10 flex flex-col items-center gap-6">
      <h2 class="font-sans text-headline-lg max-w-lg">¿Listo para encontrar tu próxima chamba?</h2>
      <p class="text-white max-w-md">
        Regístrate gratis por WhatsApp y deja que la IA de Chambia te conecte con tu próximo empleo.
      </p>
      <a [href]="whatsappLink" target="_blank" rel="noopener" class="btn-whatsapp shadow-whatsapp-glow mt-2">
        <img src="assets/icons/whatsapp-icon.png" alt="" width="22" height="20" class="w-5 h-auto">
        Empieza por WhatsApp
      </a>
    </div>
  </div>
</section>
